<div id="rainfall-summary">
  @if (!loading) {
    @if (data?.length > 0) {
      <p>{{ 'doktar_app.services.crop_monitoring.rainfall_chart_title' | translate }}</p>
      <div echarts [options]="chartOption" class="chart" style="height: 150px"></div>
      <div class="d-flex gap-1 justify-content-end align-items-center">
        <span class="title">{{ 'doktar_app.services.crop_monitoring.rainfall_chart_caption' | translate }}</span>
        <span class="date"
          >({{ lastValue?.date | luxonFormat:'d MMMM y': ('UTC'+ plantationService.selectedPlantation?.offSet) }}-{{
            'doktar_app.services.crop_monitoring.rainfall_chart_caption_day_period' | translate
          }})</span
        >
        <span class="value">{{ lastValue?.precipitation?.toFixed(1) }} mm</span>
      </div>
    } @else {
      <app-no-analysis [selectedDay]="selectedDay" />
    }
  } @else {
    <p-skeleton width="25rem" height="2rem" styleClass="mb-3" />
    <div class="d-flex gap-3">
      <p-skeleton width="10rem" height="2rem" styleClass="mb-3" />
      <p-skeleton width="10rem" height="2rem" styleClass="mb-3" />
    </div>
    <p-skeleton styleClass="mb-3" height="7rem" />
  }
</div>
